import { coverageReport } from "./coverage-report";

export default async function () {
    await coverageReport.generate();
}
